import { Logo } from '@components'

import { Button, Flex, ProgressBar, Space, Spacing } from '@billy/design-system'
import { PropsWithChildren, ReactElement, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useOnboardingSetupContext } from '../../../../contexts/OnboardingSetupContext'
import { useOnboardingNavigation } from '../../../../hooks/useOnboardingNavigation'
import { useTrackOnboarding } from '../../../../hooks/useTrackOnboarding'
import * as Styled from './styles'
import { getOnboardingStepInfo } from './utils/getOnboardingStepInfo'

export const OnboardingLayout = ({ children }: PropsWithChildren): ReactElement => {
  const { t } = useTranslation()

  const { currentStep, goToPreviousStep, isExtendedQuestionnaire, stepHistory, variant } = useOnboardingSetupContext()
  const { handleContinue, handleSkip, isActionDisabled } = useOnboardingNavigation()
  const { trackOnboarding } = useTrackOnboarding()

  useEffect(() => {
    if (!currentStep) {
      return
    }

    trackOnboarding('viewed')
  }, [currentStep, trackOnboarding])

  const { isFirstStep, progress } = getOnboardingStepInfo({ isExtendedQuestionnaire, stepHistory, variant })

  return (
    <Styled.OnboardingLayoutWrapper>
      <Styled.LogoWrapper>
        <Logo logo="logo" />
      </Styled.LogoWrapper>
      <Styled.OnboardingLayoutContent>
        <ProgressBar progress={progress} size="small" />
        <Space size="s8" />
        <Flex flexDirection="column" flexGrow={1}>
          {children}
        </Flex>
        <Space size="s32" />
        <Flex gap={Spacing.S8} justifyContent="space-between">
          {isFirstStep ? (
            <Flex />
          ) : (
            <Button icon="arrowLeft" onClick={goToPreviousStep} variant="text">
              {t('back')}
            </Button>
          )}
          <Flex gap={Spacing.S8}>
            <Button data-testid="onboarding-skip" disabled={isActionDisabled} onClick={handleSkip} variant="text">
              {t('onboarding.buttons.skip')}
            </Button>
            <Button disabled={isActionDisabled} iconRight="arrowRight" onClick={handleContinue} variant="filled">
              {t('onboarding.buttons.continue')}
            </Button>
          </Flex>
        </Flex>
      </Styled.OnboardingLayoutContent>
    </Styled.OnboardingLayoutWrapper>
  )
}
